import { ExistingUserRegistrationFormPayload } from '../../models/API.models';
import { FormGroup } from '@angular/forms';

export interface IUserService {
  registerExistingUser(formPayload: Partial<ExistingUserRegistrationFormPayload>, form: FormGroup): Promise<boolean>;
  testProtectedAPI(): Promise<boolean>;
}


export enum AuthStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
  IDLE = 'IDLE',
}

export enum UserAmilearnStatus {
  NEW = 'NEW',
  REGISTERED = 'REGISTERED',
  DEMO = 'DEMO',
  SUBSCRIBED = 'SUBSCRIBED',
}

export const DEFAULT_USER_AMILEARN_STATUS = UserAmilearnStatus.NEW;
